/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Irrigation_UpstreamInputs */

const vi_error_irrigation_upstream = /** @type {(inputs: Error_Irrigation_UpstreamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Không kết nối được hệ thống tưới SmartLab, vui lòng thử lại sau`)
};

/**

* @param {Error_Irrigation_UpstreamInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const error_irrigation_upstream = /** @type {((inputs?: Error_Irrigation_UpstreamInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Irrigation_UpstreamInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_error_irrigation_upstream(inputs)
});